import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Parallax } from 'react-scroll-parallax';

import ContentContainer from '../ContentContainer';
import withMobile from '../../hocs/withMobile';
import { CDN_ASSETS } from '../../../../constants/common';

const backgroundImg = `${CDN_ASSETS}/gift/background-blur.png`;
const palmImg = `${CDN_ASSETS}/gift/palm-corner.png`;
const doublePalmImg = `${CDN_ASSETS}/gift/double-palm.png`;
const mobilePalmImg = `${CDN_ASSETS}/gift/palm-mobile.png`;
const mobileFadedPalmImg = `${CDN_ASSETS}/gift/palm-faded-mobile.png`;
const mobilePalmWithShadowImg = `${CDN_ASSETS}/gift/palm-with-shadow-mobile.png`;

const MobilePalms = () => (
  <>
    <ParallaxWrapper top={-25} right={-15}>
      <Parallax y={[20, -20]}>
        <StyledMobilePalm />
      </Parallax>
    </ParallaxWrapper>
    <ParallaxWrapper top={-95} left={-165}>
      <Parallax y={[10, -20]}>
        <StyledMobilePalm flipped />
      </Parallax>
    </ParallaxWrapper>
    <ParallaxWrapper top={90} right={-150}>
      <Parallax y={[40, -30]}>
        <StyledFadedMobilePalm />
      </Parallax>
    </ParallaxWrapper>
    <ParallaxWrapper top={60} left={-150}>
      <Parallax y={[30, -15]}>
        <StyledFadedMobilePalm flipped />
      </Parallax>
    </ParallaxWrapper>
    <ParallaxWrapper top={400} right={-100}>
      <Parallax y={[15, -10]}>
        <StyledMobilePalmWithShadow />
      </Parallax>
    </ParallaxWrapper>
    <ParallaxWrapper top={340} left={-40}>
      <Parallax y={[10, -20]}>
        <StyledMobilePalmWithShadow flipped />
      </Parallax>
    </ParallaxWrapper>
  </>
);

const DesktopPalms = () => (
  <>
    <ParallaxWrapper top={-20} left={-45}>
      <Parallax y={[20, -10]}>
        <StyledCornerPalm />
      </Parallax>
    </ParallaxWrapper>
    <ParallaxWrapper top={240} left={-40}>
      <Parallax y={[50, -50]}>
        <StyledPalm flipped />
      </Parallax>
    </ParallaxWrapper>
    <ParallaxWrapper top={285} right={-20}>
      <Parallax y={[30, -30]}>
        <StyledPalm />
      </Parallax>
    </ParallaxWrapper>
  </>
);

export const HeaderWrapper = ({ children, isMobile }) => {
  const PalmsComp = isMobile ? MobilePalms : DesktopPalms;
  return (
    <StyledHeaderWrapper>
      <PalmsComp />
      <ContentContainer>{children}</ContentContainer>
    </StyledHeaderWrapper>
  );
};

const ParallaxWrapper = styled.div`
  position: absolute;
  z-index: 1;
  top: ${(props) => `${props.top}px`};

  ${(props) =>
    props.left &&
    css`
      left: ${({ left }) => `${left}px`};
    `}

  ${(props) =>
    props.right &&
    css`
      right: ${({ right }) => `${right}px`};
    `}
`;

const StyledHeaderWrapper = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  width: 100%;
  justify-content: center;
  background-image: radial-gradient(
    circle at 50% 40%,
    #fff,
    #2eb9e5 34%,
    #139cd4 42%,
    #025a9f 76%
  );

  &::before {
    position: absolute;
    z-index: 0;
    bottom: -40%;
    width: 100%;
    height: 100%;
    content: '';
    background-image: url(${backgroundImg});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
`;

const StyledCornerPalm = styled.img.attrs({ src: palmImg })`
  position: relative;
  width: 50vw;
  max-width: 500px;
`;

const StyledPalm = styled.img.attrs({ src: doublePalmImg })`
  position: relative;
  width: 50vw;
  max-width: 450px;

  ${(props) =>
    props.flipped &&
    css`
      transform: scaleX(-1);
    `};
`;

const StyledMobilePalm = styled.img.attrs({ src: mobilePalmImg })`
  position: relative;
  width: 55vw;
  max-width: 250px;
  transform: rotate(6deg);

  ${(props) =>
    props.flipped &&
    css`
      width: 87vw;
      max-width: 300px;
      transform: rotate(34deg) scaleX(-1);
    `}
`;

const StyledFadedMobilePalm = styled.img.attrs({ src: mobileFadedPalmImg })`
  position: relative;
  width: 69vw;
  max-width: 250px;
  transform: rotate(-12deg);

  ${(props) =>
    props.flipped &&
    css`
      width: 72vw;
      transform: rotate(12deg) scaleX(-1);
    `}
`;
const StyledMobilePalmWithShadow = styled.img.attrs({
  src: mobilePalmWithShadowImg,
})`
  position: relative;
  width: 80vw;
  max-width: 250px;
  transform: rotate(10deg);

  ${(props) =>
    props.flipped &&
    css`
      width: 50vw;
      transform: scaleX(-1);
    `}
`;

HeaderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default React.memo(withMobile(HeaderWrapper));
